$(function () {
    $(".freccia-next").mousedown(function (evt) {
        var table_to_scroll = $(this).parent().parent().next().children(".resto-tabella")
        scroll(table_to_scroll, 1);
    });
    $(".freccia-prev").mousedown(function (evt) {
        var table_to_scroll = $(this).parent().parent().next().children(".resto-tabella")
        scroll(table_to_scroll, -1);
    });
})


function scroll (obj, direzione) {
    var scrollOf = obj.scrollLeft() + ( 72 * direzione );
    if(scrollOf % 72 !== 0 ){
        scrollOf = scrollOf + (72 - (scrollOf % 72))
    }
    obj.scrollLeft(scrollOf);
}